/**
 * @generated SignedSource<<e5553bd3f2d0b1540e667b49ee2c25be>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type HelpLayoutForgeElementPages = "approvals" | "create_request" | "help_center" | "my_requests" | "portal" | "profile" | "view_request" | "%future added value";
export type HelpLayoutForgeElementType = "FOOTER" | "HEADER_AND_SUBHEADER" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type forgeElementFragment$data = {
  readonly forgeElementPage: HelpLayoutForgeElementPages;
  readonly forgeElementType: HelpLayoutForgeElementType;
  readonly " $fragmentType": "forgeElementFragment";
};
export type forgeElementFragment$key = {
  readonly " $data"?: forgeElementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"forgeElementFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "forgeElementFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "forgeElementType"
    },
    {
      "kind": "ScalarField",
      "name": "forgeElementPage"
    }
  ],
  "type": "HelpLayoutForgeElement"
};

(node as any).hash = "7cbd50b7d297d1d7e5a2129168127d6e";

export default node;
